import TitleSkeleton from './TitleSkeleton';

export default TitleSkeleton;
